import { render } from "./referee-change-password.vue?vue&type=template&id=78c58bd2&scoped=true"
import script from "./referee-change-password.vue?vue&type=script&lang=js"
export * from "./referee-change-password.vue?vue&type=script&lang=js"

import "./referee-change-password.vue?vue&type=style&index=0&id=78c58bd2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c58bd2"]])

export default __exports__